import React, { Component } from 'react';
import ReactApexChart from 'apexcharts'
import Chart from "react-apexcharts";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import {connect} from 'react-redux'
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class ChartItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        }
    }
    componentDidMount() {
        this.props.socket !== null ? this.getData(this.props.socket,this.props.id) : console.log();
    }
    componentWillReceiveProps(nextProps) {
        nextProps.socket !== null ? this.getData(nextProps.socket,nextProps.id) : console.log();
    }
    getData = (socket , id) => {
        if(id && socket){
            socket.on('items_detail', data => {
                this.setState({ prices_labels: data.prices_labels,prices_values:data.prices_values, information: data.item, connected: socket.connected })
                
            })
            socket.emit("items_detail",{id,from:'',to:''});
        }

    }

    handleClose = () => {
        this.props.closeBox();
    }
    render() {
        const { openChart , id } = this.props;
        const {prices_labels , prices_values , information } = this.state;
        const options = {
            chart: {
                id: "basic-bar"
            },
            xaxis: {
                categories: prices_labels
            }
        },
        
        series =  [
            {
                name: information ? `فروش(${information.unit})` : "",
                data: prices_values
            }
        ]
        return (

            <Dialog
                open={openChart}
                TransitionComponent={Transition}
                keepMounted
                className="add-item"
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title"> {information ? information.name :""} </DialogTitle>
                <Chart
                    options={options}
                    series={series}
                    type="area"
                    width="100%"
                    height="400"
                />
                <DialogActions>
                    <Button onClick={this.handleClose} className="cancel-btn chart-cancel" color="primary" style={{ marginLeft: 15 }}>
                        بستن
                    </Button>

                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = state => {
    return {
        socket: state.setSocket,
    }
}
export default connect(mapStateToProps)(ChartItem);